import { useState } from "react";
import styles from "./WDP_SinglePreviewFromEditState.module.css";
const SinglePreviewFromEditState = ({ state, previewImage }) => {
  return (
    <div
      style={{
        width: "900px",
        height: "900px",
      }}
      className={styles.copied_preview_image_wrapper}
    >
      <img
        className={styles.copied_preview_image}
        src={previewImage ? URL.createObjectURL(previewImage) : ""}
        width={"900px"}
        height={"900px"}
        alt="pv_btm"
        crossOrigin="anonymous"
      />
    </div>
  );
};

export default SinglePreviewFromEditState;
